
export class FindingDto {
    findingId;
    title='';
    content='';
    isFinancial=false;
    postControlInfo;
    blockInList;
    corrections=[];
    recommendations=[];
    findingKind;
}


















